module.exports = __webpack_public_path__ + "img/53.0a2ece33.png";